'use client'

import Image from 'next/image'
import { useMediaQuery } from '@segway/core'

import { Link, useRouter } from '@/i18n/navigation'

import { HelpMeChooseActionButton } from '../HelpMeChooseActionButton'
import { HelpMeChooseItem } from '../types'

import styles from '@/components/Homepage/_components/bestSeller/page.module.css'

interface FloorHelpMeChooseProps {
  helpMeChooseItem: HelpMeChooseItem
}

const FloorHelpMeChoose = ({ helpMeChooseItem }: FloorHelpMeChooseProps) => {
  const router = useRouter()
  const responsive = useMediaQuery()

  const textColor = helpMeChooseItem?.text_color || '#ffffff'

  return (
    <div className={styles.item}>
      <Link
        className="relative flex h-[165px] w-full flex-col justify-start overflow-hidden rounded-[12px] font-miSansDemiBold450 xl:h-[453px] xl:rounded-[20px]"
        href={helpMeChooseItem?.link}
        target={helpMeChooseItem?.open_in_new_window === '1' ? '_blank' : '_self'}>
        <div>
          <Image
            src={
              responsive && responsive.xl ? helpMeChooseItem?.pc_image : helpMeChooseItem?.mob_image
            }
            alt={helpMeChooseItem?.image_alt}
            fill
            style={{ objectFit: 'cover' }}
          />
        </div>
        <div className="relative flex-col gap-[48px] pl-[16px] pt-[35px] xl:flex xl:pl-[61px] xl:pt-[55px]">
          <div
            className="flex flex-col gap-[8px]"
            style={{
              color: textColor,
            }}>
            <p className="max-w-[500px] font-miSansDemiBold450 text-xl leading-[1.2] xl:font-miSansSemiBold520 xl:text-[48px]">
              {helpMeChooseItem?.title}
            </p>
            <p className="max-w-[245px] font-miSansRegular330 text-sm xl:font-miSansMedium380 xl:text-2xl xl:leading-[1.4]">
              {helpMeChooseItem?.description}
            </p>
          </div>
          <div className={responsive && !responsive.xl ? 'mt-[9px]' : ''}>
            <HelpMeChooseActionButton
              className="h-[32px] py-[8px] xl:h-[44px]"
              onClick={() => {
                if (helpMeChooseItem?.open_in_new_window === '1') {
                  window.open(helpMeChooseItem?.link, '_blank')
                } else {
                  router.push(helpMeChooseItem?.link)
                }
              }}
              bgColor={helpMeChooseItem?.button_background_color}
              textColor={helpMeChooseItem?.button_text_color}>
              <span className="font-miSansDemiBold450 text-[13px] leading-[16px]">
                {helpMeChooseItem?.button_text}
              </span>{' '}
            </HelpMeChooseActionButton>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default FloorHelpMeChoose
